import Component from '../core/Component';
import $ from 'jquery';
import enquire from 'enquire.js';
import { queries } from '../core/config';
import { throttle } from 'lodash';

export default class Share extends Component
{
    constructor($element)
    {
        super($element);
        setTimeout(() => {
            this.offset = this.$element.offset().top;
            this.$parent = this.$element.parent();
            this.$window = $(window);
            this.start = this.offset - 120;
            this.end = $('.article__content').height() + this.start - 340;
            this.height = $('.article__content').height() - 340;
        }, 600)
    }

    prepare()
    {
        setTimeout(() => {
            enquire.register(queries.mediumUp, {
                match: () => {
                    this.attach();
                },
                unmatch: () => {
                    this.detach();
                }
            });
        }, 600)
    }

    destroy () {
        this.detach();
    }

    attach () {
        $(window).on('scroll', throttle(::this.onScroll, 16));
    }

    detach () {
        $(window).off('scroll', throttle(::this.onScroll, 16));
    }

    onScroll(event) {
        var scrollTop = $(window).scrollTop();
        if (scrollTop >= this.start && scrollTop <= this.end) {
            this.$parent.addClass('share--fixed');
            this.element.style.top = "0px";
        } else if (scrollTop < this.start) {
            this.$parent.removeClass('share--fixed');
            this.element.style.top = 0 + "px";
        } else {
            this.$parent.removeClass('share--fixed');
            this.element.style.top = this.height + "px";
        }
    }
}


// WEBPACK FOOTER //
// ./components/Share.js